import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Dialog, Slide } from '@mui/material';

const PREFIX = 'Feedback';

const classes = {
  header: `${PREFIX}-header`,
  close: `${PREFIX}-close`,
};

const StyledDialog = styled(Dialog)({
  [`& .${classes.header}`]: {
    display: 'flex',
    padding: '0 1rem',
    justifyContent: 'flex-end',
  },
  [`& .${classes.close}`]: {
    border: 'none',
    fontWeight: 700,
    fontSize: '2rem',
    color: '#aeaeae',
    backgroundColor: 'transparent',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const SCRIPT_SRC = import.meta.env.REACT_APP_THUMBUP_FEEDBACK_WIDGET;
const SCRIPT_APP_URL = import.meta.env.REACT_APP_THUMBUP_FEEDBACK_DATA_URL;

function Feedback({ open, onCancel }) {
  const injectWidget = () => {
    if (!SCRIPT_SRC) return;

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;

    document.body.appendChild(script);
  };

  useEffect(() => {
    injectWidget();

    return () => {
      const scripts = document.getElementsByTagName('script');

      for (let script of scripts) {
        if (script.src.includes('reviewmgr')) script.remove();
      }
    };
  }, []);

  return (
    <StyledDialog open={open} fullWidth maxWidth="sm" TransitionComponent={Transition} onClose={onCancel}>
      <div className={classes.header}>
        <button type="button" className={classes.close} onClick={onCancel}>
          &times;
        </button>
      </div>
      <div className="reviewmgr-embed" data-url={SCRIPT_APP_URL}></div>
    </StyledDialog>
  );
}

export default Feedback;
